import { TreeBoxControl } from './control.model';
import { TreeBoxController } from './controller.model';

export function getNames(ctrls: (TreeBoxControl | TreeBoxController)[]): string[] {
  return ctrls.reduce((acc, ctrl) => ('children' in ctrl ? [...acc, ...getNames(ctrl.children)] : [...acc, ctrl.name]), []);
}
